<template>
    <div>
        <div class="section section_four">
            <div class="main_content">
                <div class="container">
                    <div class="heading_section">
                        <h2 data-aos="fade-up">{{this.climate.title}}</h2>
                    </div>
                    <div class="row">
                        
                        <div class="col-md-12 full-content ml-md-auto mx-auto mb-md-0 mx-md-0 mb-4">
                            <div class="custom_border mx-auto">
                                <p data-aos="fade-up" v-html="this.climate.RichText">
                                    <!-- {{this.climate.RichText}} -->
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 full-content mx-md-0 mx-auto mb-md-0 mb-4">
                            <div class="custom_border">
                                <p data-aos="fade-up">
                                    {{this.climate.RichText2}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 full-content ml-md-auto mx-md-0 mx-auto mb-md-0 mb-40">
                            <div class="custom_border mx-auto">
                                <p data-aos="fade-up" v-html="this.climate.RichText3">
                                     <!-- {{this.climate.RichText3}} -->
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 mb-4">
                            <div class="icon">
                                <img :src="require(`../../assets/images/corporate-sustainability/${this.climate.Icons[0].image}`)" alt="" class="img-fluid">
                                <!-- <img :src="require(`../../assets/images/corporate-sustainability/${image}`)" alt="" class="img-fluid"> -->
                            </div>
                            <div class="custom_border note">
                                <h5 v-html="this.climate.RichText4" data-aos="fade-up">
                                    {{this.climate.RichText4}}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="category-order" data-aos="fade-up">
                        {{this.climate.RichText5}} 
                    </div>  
                    <div class="category-title big" data-aos="fade-up">
                        {{this.climate.RichText6}} 
                    </div>
                    <div class="mr-100-desktop">
                        <div class="row col-gap-100">
                            <div class="col-md-6">
                                <div class="category-order">
                                    {{this.climate.RichText7}} 
                                </div>  
                                <div class="category-title border-b">
                                    {{this.climate.RichText8}} 
                                </div>
                                <div class="country-categories">
                                    <div class="country" >
                                        <div class="flag">
                                            <img src="@/assets/images/corporate-sustainability/svg/iraq.svg" alt="">
                                        </div>
                                        <div class="value">
                                            <span class="counter" data-number="20"></span>
                                            <span>%</span>
                                        </div>
                                    </div>
                                    <div class="country">
                                        <div class="flag">
                                            <img src="@/assets/images/corporate-sustainability/svg/sudan.svg" alt="">
                                        </div>
                                        <div class="value">
                                            <span class="counter" data-number="15"></span>
                                            <span>%</span>
                                        </div>
                                    </div>
                                    <div class="country">
                                        <div class="flag">
                                            <img src="@/assets/images/corporate-sustainability/svg/south-sudan.svg" alt="">
                                        </div>
                                        <div class="value">
                                            <span class="counter" data-number="25"></span>
                                            <span>%</span>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="category-order" data-aos="fade-up">
                                     {{this.climate.RichText9}}  
                                </div>  
                                <div class="category-title border-b" data-aos="fade-up">
                                     {{this.climate.RichText10}} 
                                </div>
                                <div class="country-categories">
                                    <div class="country" >
                                        <div class="flag">
                                            <img src="@/assets/images/corporate-sustainability/svg/bahrain.svg" alt="">
                                        </div>
                                        <div class="value">
                                            <span class="counter" data-number="5"></span>
                                            <span>%</span>
                                        </div>
                                    </div>
                                    <div class="country">
                                        <div class="flag">
                                            <img src="@/assets/images/corporate-sustainability/svg/jordan.svg" alt="">
                                        </div>
                                        <div class="value">
                                            <span class="counter" data-number="10"></span>
                                            <span>%</span>
                                        </div>
                                    </div>
                                    <div class="country">
                                        <div class="flag">
                                            <img src="@/assets/images/corporate-sustainability/svg/kuwait.svg" alt="">
                                        </div>
                                        <div class="value">
                                            <span class="counter" data-number="7"></span>
                                            <span>%</span>
                                        </div>
                                    </div>
                                    <div class="country">
                                        <div class="flag">
                                            <img src="@/assets/images/corporate-sustainability/svg/saudi-arabia.svg" alt="">
                                        </div>
                                        <div class="value">
                                            <span class="counter" data-number="8"></span>
                                            <span>%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bottom-categories">
                        <div class="category-order" data-aos="fade-up">
                              {{this.climate.RichText11}} 
                        </div> 
                        <div class="category-title small" data-aos="fade-up">
                             {{this.climate.RichText12}} 
                        </div>
                        <div class="category-order" data-aos="fade-up">
                            {{this.climate.RichText13}} 
                        </div> 
                        <div class="category-title small" data-aos="fade-up">
                            {{this.climate.RichText14}} 
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Data from "./json/data.json";
const climate = [];
export default {
    name:"climate",
    props:{
        climate: Object
    },
    mounted(){
        this.counterAnimation();
    }
}
</script>

<style lang="scss" scoped>
.section_four{
    @include Background('../../assets/images/corporate-sustainability/bg4.png');
    h2{
        @include Heading(center)
    }
    .note-wrapper {
        margin-left: rem(120px);
    }
    .note {
        
        max-width: 100%;
        margin-top: rem(30px);
        padding-top: rem(30px);
        margin-bottom: rem(60px);
        &.custom_border {
            &:before {
                top: 0;
            }
        }
        h5 {
            font-size: rem(40px);
            color: #ffffff;
            font-weight: lighter;
            @media screen and (max-width:1600px) {
                font-size: rem(30px); 
            }
            /deep/ span {
                font-weight: 700; 
                &.big {
                    font-size: rem(50px);
                    @media screen and (max-width:1600px) {
                        font-size: rem(35px); 
                    }
                }
            }
        }
    }
    .mr-100-desktop {
        margin-right: rem(100px);
        @media screen and (max-width:767px){
            margin-right:0;
        }
    }
    .category-order {
        font-size: rem(20px);
        color: #ffffff;
        font-weight: 700;
        position: relative;
        padding-left: rem(60px);
        margin-bottom: rem(15px);
        &:before {
            position: absolute;
            left: 0;
            background-color: #ffffff;
            content: '';
            height: 2px;
            width: rem(39px);
            top: 50%;
            transform: translateY(-50%);
        }
    }
    .category-title {
        font-size: rem(40px);
        color: #ffffff;
        font-weight: 700;
        margin-bottom: rem(30px);
        text-transform: uppercase;
        @media screen and (max-width:1600px) {
            font-size: rem(30px); 
        }
        &.big {
            font-weight: 900;
            font-size: rem(60px);
            text-transform: capitalize;
            margin-bottom: rem(55px);
            @media screen and (max-width:1600px) {
                font-size: rem(40px); 
            }
        }
        &.border-b {
            padding-bottom: rem(45px);
            margin-bottom: rem(45px);
            border-bottom: 6px solid #3BB68F;
        }
        &.small {
            font-weight: normal;
            font-size: rem(30px);
            line-height: 1.3;
            text-transform: capitalize;
            @media screen and (max-width:1600px) {
                font-size: rem(25px);
            }
        }
    }
    // .bottom-categories {
    //     max-width: 1100px;
    //     margin-left: auto;
    // }
    .country-categories {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: rem(45px);
        .country {
            text-align: center;
            font-size: rem(50px);
            color: #ffffff;
            font-weight: 700;
            @media screen and (max-width:1600px) {
                font-size: rem(35px);
            }
            .flag {
                margin-bottom: rem(40px);
                @media screen and (max-width:1600px) {
                    max-width: 95px;
                    margin-left: auto;
                    margin-right: auto;
                    padding: 0px 10px;
                }
                @media screen and (max-width:500px ) {
                    max-width: 60px;
                    margin-left: auto;
                    margin-right: auto;
                }
            }
            @media screen and (max-width:500px) {
                font-size: rem(40px);
            }
        }
    }
    .icon{
        max-width: 80px;
        @media screen and (max-width:500px){
             max-width: 50px;
        }
    }
    @media screen and (max-width:767px){
        /deep/{
            .col-gap-100{
                margin-left: 0px!important;
                margin-right: 0 !important;
                >div{
                    padding-left: 0px!important;
                    padding-right: 0px!important;
                }
            }
        }
    }
}

// arabic
    [lang="ar"] {
        .section_four{
           
            
            .note-wrapper {
                margin-right: rem(120px);
                margin-left:0;
            }
            
            .mr-100-desktop {
                margin-left: rem(100px); margin-right: 0;
                @media screen and (max-width:767px){
                    margin-left:0;
                }
            }
            .category-order {
                
                padding-right: rem(60px); padding-left: 0;
                &:before {
                    right: 0;
                    left: auto;
                }
            }
            
            
            
            
        }
    }
</style> 